import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'orgbrain-call-join-dialog',
  templateUrl: 'call-join-dialog.component.html',
  standalone: false,
})
export class CallJoinDialogComponent {
  public dialogRef = inject(MatDialogRef<CallJoinDialogComponent>);
  public data = inject(MAT_DIALOG_DATA);

  inviterName: string;
  conversationName: string;
  acceptButtonText: string;
  declineButtonText: string;
  joinPromptText: string;
  inviterPhotoUrl?: string; // Optional URL for profile photo

  onAccept() {
    this.dialogRef.close(true);
  }

  onDecline() {
    this.dialogRef.close(false);
  }
}
